import { render } from "./PatientRecords.vue?vue&type=template&id=bfd7ce36"
import script from "./PatientRecords.vue?vue&type=script&lang=js"
export * from "./PatientRecords.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__